<ng-container *ngIf="availableSizes">
  <ng-container *ngFor="let size of availableSizes; let i = index">
    <app-button-menu-item
      (onClick)="onDownload.emit(size)"
      [fullWidth]="true"
      [name]="'download-' + size"
      location="gallery-download-menu-options"
      [class.last]="size === 'original' && i !== 0"
    >
      <strong>{{ size | capitalize }}</strong>
      <span *ngIf="size === 'original'">({{ sizesEstimates[size] | dataUnits : 0 : 0 }})</span>
      <span *ngIf="size !== 'original'">(~{{ sizesEstimates[size] | dataUnits : 0 : 0 }})</span>
    </app-button-menu-item>
  </ng-container>

  <div *ngIf="!availableSizes.length" class="no-downloads-available">No downloads available</div>
</ng-container>
